import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content authored by admins before rendering it to the DOM.
 *
 * Document and training-content authoring is currently gated to Security
 * Heads, so the source is trusted. We still sanitize as defense-in-depth:
 *  - protects against a future role-permission regression that lets a
 *    less-trusted role inject content
 *  - protects every other team member if an admin's account is compromised
 *  - removes accidental copy-pasted <script> tags from external sources
 *
 * Allows the standard formatting tags + safe attributes the prototype
 * actually uses; strips event handlers, inline scripts, iframes, etc.
 */
export const sanitizeHtml = (dirty) => {
  if (typeof dirty !== 'string' || !dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'b', 'i', 'em', 'strong', 'u', 's', 'mark',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'code', 'pre',
      'a', 'img', 'span', 'div', 'hr',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'style',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'id', 'target', 'rel', 'style'],
    ALLOW_DATA_ATTR: false,
  });
};

export default sanitizeHtml;
